/**
 * Normalizes relationship strings to ensure proper capitalization
 * Ensures "Grandson"/"Granddaughter" not "GrandSon"/"GrandDaughter"
 * Ensures "Gr Grandson" not "Gr GrandSon" or "Gr gr grandson"
 * @param {string} relation - The relation string to normalize
 * @returns {string} - The normalized relation string
 */
export function normalizeRelation(relation) {
    if (!relation || typeof relation !== 'string') return relation;
    
    // Convert to lowercase first to normalize
    const lower = relation.toLowerCase().trim();
    
    // Handle "Gr " prefixes - extract them and keep as "Gr " (capital G, lowercase r, space)
    let remaining = lower;
    let grPrefixes = '';
    
    // Extract all "gr " prefixes
    while (remaining.startsWith('gr ')) {
        grPrefixes += 'Gr ';
        remaining = remaining.slice(3).trim();
    }
    
    // Now handle the remaining part - should be "grandson" or "granddaughter"
    // Ensure proper capitalization: "Grandson" or "Granddaughter"
    let core = remaining;
    if (core === 'grandson') {
        core = 'Grandson';
    } else if (core === 'granddaughter') {
        core = 'Granddaughter';
    } else if (core.startsWith('grand')) {
        // Handle cases like "grandson-in-law" etc.
        if (core.includes('grandson')) {
            core = core.replace(/\bgrandson\b/g, 'Grandson');
        } else if (core.includes('granddaughter')) {
            core = core.replace(/\bgranddaughter\b/g, 'Granddaughter');
        } else {
            // For other "grand" words, capitalize first letter
            core = 'Grand' + core.slice(5);
            core = core.charAt(0).toUpperCase() + core.slice(1);
        }
    } else {
        // For other relations, just capitalize first letter
        core = core.charAt(0).toUpperCase() + core.slice(1);
    }
    
    // Combine: "Gr Gr Gr " + "Grandson" = "Gr Gr Gr Grandson"
    return (grPrefixes + core).trim();
}

